import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lic_admin_mixta',
  templateUrl: './lic_admin_mixta.component.html',
  styleUrls: ['./lic_admin_mixta.component.css']
})
export class Lic_admin_mixtaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
